export function setStyle(injectStyles: Partial<CSSStyleDeclaration>, element: HTMLElement) {
  Object.entries(injectStyles).forEach(([key, value]) => {
    (element.style as any)[key] = value;
  });
}
